import { LabelHTMLAttributes } from "react";

export default function InputLabel({
    value,
    className = "",
    children,
    required = false,
    fontSize = "text-sm",
    ...props
}: LabelHTMLAttributes<HTMLLabelElement> & {
    value?: string;
    fontSize?: "text-sm" | "text-base" | "text-lg" | "text-xl";
    required?: boolean;
}) {
    return (
        <label
            {...props}
            className={
                `block ${fontSize} font-medium text-gray-700 ` + className
            }
        >
            {value ? value : children}
            {required && <span className="text-red4 text-base">*</span>}
        </label>
    );
}
